<template>
  <v-card flat>
    <v-card-title>
      <h6 class="title pt-2">Profile Information</h6>
    </v-card-title>
    <v-card-text>
      <app-info-field label="First Name" component-class="subheading">
        {{ user.firstName }}
      </app-info-field>
      <app-info-field label="Last Name" component-class="subheading">
        {{ user.lastName }}
      </app-info-field>
      <app-info-field label="Institution" component-class="subheading">
        {{ org.name }}
      </app-info-field>
      <app-info-field label="Email Address" component-class="subheading">
        {{ user.email }}
      </app-info-field>
      <app-info-field v-if="shouldShowPasswordReset" label="Password" component-class="subheading">
        <v-btn
          color="primary"
          class="font-weight-medium subheading elevation-4"
          @click="changePassword"
          >Update Password</v-btn
        >
      </app-info-field>
      <manage-account-notifications
        v-if="showTrialNotificationPrefs"
        class="pr-5"
      ></manage-account-notifications>
    </v-card-text>
  </v-card>
</template>

<script>
import ManageAccountNotifications from '@/components/manage/ManageAccountNotifications'
import { permissionsMixin } from '@/mixins/permissions'
import { isFeatureOn } from '@/helpers/feature-flag-helper'
import _ from 'lodash'

export default {
  components: { ManageAccountNotifications },
  mixins: [permissionsMixin],
  props: {
    org: { type: Object, required: true },
    user: { type: Object, required: true }
  },
  computed: {
    shouldShowPasswordReset() {
      const identityProvider = _.get(this.user, 'identityProvider', null)
      return identityProvider === 'viper' || !identityProvider
    },
    showTrialNotificationPrefs() {
      return isFeatureOn('trials') && this.hasAnyPermission('TRIAL_READ')
    }
  },
  methods: {
    changePassword() {
      window.open(this.$appConfig.VUE_APP_KEYCLOAK_CHANGE_PASSWORD_URL, '_blank')
    }
  }
}
</script>
